module.exports = __webpack_public_path__ + "static/media/grid.83c563a5.svg";